import { useResource } from "@/lib/api";
import { formatAUD } from "@/lib/format";

export default function CurrencyTab() {
  const { data } = useResource("/settings");
  return (
    <section className="grid gap-4 md:grid-cols-2" data-testid="currency-section">
      <div className="border border-border bg-card p-6">
        <div className="text-xs uppercase tracking-wider text-muted-foreground">Currency</div>
        <div className="font-display text-4xl font-semibold mt-3" data-testid="currency-value">{data?.currency || "AUD"}</div>
        <p className="text-sm text-muted-foreground mt-2">Australian dollar. All amounts are stored as exact decimals to the cent.</p>
        <div className="font-mono mt-4 text-emerald-300" data-testid="currency-example">{formatAUD("12450.00")}</div>
      </div>
      <div className="border border-border bg-card p-6">
        <div className="text-xs uppercase tracking-wider text-muted-foreground">Financial year</div>
        <div className="font-display text-4xl font-semibold mt-3" data-testid="fy-range">{data ? `${data.fy_start} – ${data.fy_end}` : "1 July – 30 June"}</div>
        <p className="text-sm text-muted-foreground mt-2">Transactions are assigned to a financial year from their date automatically.</p>
      </div>
    </section>
  );
}
